import { useParams } from 'react-router-dom'
import { GameDetailPage } from '@/pages/GameDetailPage'

export const CountryGameRoute: React.FC = () => {
    const { slug, platformSlug } = useParams<{
        slug: string
        platformSlug?: string
    }>()

    // The I18nProvider now handles country switching automatically based on the URL
    // Just render the GameDetailPage with the extracted slug and platformSlug
    return <GameDetailPage slug={slug} platformSlug={platformSlug} />
} 